import axios from 'axios';

const apiBrasil = axios.create({
  baseURL: 'https://api.brasilaberto.com/v1',
});

export default apiBrasil;
